import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent implements OnInit {

  constructor(
    private readonly dialogRef:MatDialogRef<ConfirmDeleteComponent>
  ) { }

  ngOnInit() {
  }

  close(response:boolean){
    this.dialogRef.close(response)
  }

}
